import * as stylex from "@stylexjs/stylex";
import { spacing } from "@softmax/design-system/tokens.stylex";
import type { ReactNode } from "react";

export function HeroAboutView({ children }: Readonly<{ children: ReactNode }>) {
  return <div {...stylex.props(styles.about)}>{children}</div>;
}

const styles = stylex.create({
  about: {
    display: "flex",
    flexDirection: "column",
    gap: spacing.space8,
    maxWidth: 640,
  },
});
